// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #000;
  padding: 4rem 0 2rem;
  position: relative;
}

.footer-line {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(191,0,255,0.3), transparent);
  margin-bottom: 4rem;
}

.footer-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.footer-brand img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 4px;
  filter: invert(1) sepia(1) hue-rotate(240deg) saturate(4);
}

.footer-brand span {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  background: linear-gradient(90deg, #fff, #bf00ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.footer-tagline {
  font-size: 0.85rem;
  color: rgba(255,255,255,0.3);
  letter-spacing: 0.08em;
}

.footer-links {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-links a {
  font-size: 0.75rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.3);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #bf00ff;
}

.footer-copy {
  font-size: 0.72rem;
  color: rgba(255,255,255,0.15);
  letter-spacing: 0.1em;
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;EACjD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".footer {\n  background: #000;\n  padding: 4rem 0 2rem;\n  position: relative;\n}\n\n.footer-line {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(191,0,255,0.3), transparent);\n  margin-bottom: 4rem;\n}\n\n.footer-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  text-align: center;\n}\n\n.footer-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n\n.footer-brand img {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  border-radius: 4px;\n  filter: invert(1) sepia(1) hue-rotate(240deg) saturate(4);\n}\n\n.footer-brand span {\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  background: linear-gradient(90deg, #fff, #bf00ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.footer-tagline {\n  font-size: 0.85rem;\n  color: rgba(255,255,255,0.3);\n  letter-spacing: 0.08em;\n}\n\n.footer-links {\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.footer-links a {\n  font-size: 0.75rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.3);\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.footer-links a:hover {\n  color: #bf00ff;\n}\n\n.footer-copy {\n  font-size: 0.72rem;\n  color: rgba(255,255,255,0.15);\n  letter-spacing: 0.1em;\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
